import { PlaceholderInput, PlaceholderFlattenInput } from './PlaceholderInput';
import { ifEmpty, isEmpty, isNotEmpty, isTimeFormat } from '../Service/Utils';

import copy from 'copy-to-clipboard';
import 'react-virtualized/styles.css';
import { CellMeasurerCache } from 'react-virtualized';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
    Row,
    Col,
    Button,
    Result,
    Popconfirm,
    Progress,
    InputNumber,
    Radio,
    Switch,
    Checkbox,
    Statistic,
    Input,
    Divider,
    Modal,
    Space,
    message
} from 'antd';
import { PauseOutlined, ReloadOutlined, DownloadOutlined, DeleteOutlined, CopyOutlined } from '@ant-design/icons';

import { HotTable } from '@handsontable/react';

// import the core library.
//import ReactEchartsCore from 'echarts-for-react/lib/core';
import ReactEcharts from 'echarts-for-react';

// then import echarts modules those you have used manually.
//import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
//import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/pie';
// import 'echarts/lib/chart/scatter';
// import 'echarts/lib/chart/radar';

// import 'echarts/lib/chart/map';
// import 'echarts/lib/chart/treemap';
// import 'echarts/lib/chart/graph';
// import 'echarts/lib/chart/gauge';
// import 'echarts/lib/chart/funnel';
// import 'echarts/lib/chart/parallel';
// import 'echarts/lib/chart/sankey';
// import 'echarts/lib/chart/boxplot';
// import 'echarts/lib/chart/candlestick';
// import 'echarts/lib/chart/effectScatter';
// import 'echarts/lib/chart/lines';
// import 'echarts/lib/chart/heatmap';

// import 'echarts/lib/component/graphic';
// import 'echarts/lib/component/grid';
// import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/polar';
// import 'echarts/lib/component/geo';
// import 'echarts/lib/component/parallel';
// import 'echarts/lib/component/singleAxis';
// import 'echarts/lib/component/brush';

import 'echarts/lib/component/title';

// import 'echarts/lib/component/dataZoom';
// import 'echarts/lib/component/visualMap';

// import 'echarts/lib/component/markPoint';
// import 'echarts/lib/component/markLine';
// import 'echarts/lib/component/markArea';

// import 'echarts/lib/component/timeline';
// import 'echarts/lib/component/toolbox';

// import 'zrender/lib/vml/vml';

// The usage of ReactEchartsCore are same with above.

const colors1 = ['#ffccc7', '#ffd8bf', '#ffe7ba', '#fff1b8', '#ffffb8', '#f4ffb8', '#d9f7be', '#b5f5ec',
    '#bae7ff', '#d6e4ff', '#ffd6e7'];
const colors2 = ['#52c41a', '#13c2c2', '#1890ff', '#eb2f96', '#722ed1', '#2f54eb', '#1890ff', '#13c2c2', '#52c41a',
    '#a0d911', '#ffec3d', '#ffc53d', '#fa8c16', '#fa541c', '#f5222d'];
const colors3 = [
    'rgb(99,116,199)',
    'rgb(57,184,255)',
    'rgb(101,202,146)',
    'rgb(157,235,242)',
    'rgb(88,133,226)',
    'rgb(242,212,12)',
    'rgb(203,135,98)',
    'rgb(189,184,230)',
    'rgb(173,215,111)',
    'rgb(137,124,189)',
    'rgb(176,187,220)',
    'rgb(230,220,161)',
]

class BlockChart extends React.Component {

    render() {
        return <div
            class='datap-dqg-chart'
            style={{
                width: '100%',
                height: this.props.height,
                //border
            }}
        >
        </div>;
    }
}

class BarChart extends React.Component {

    render() {
        //console.log(this.props.data);
        const markPoint = {
            label: {
                formatter: params => Charts.format(this.props.chart, params.value)
            },
            data: []
        };
        if (this.props.options.markMinPoint) {
            markPoint.data.push({
                type: 'min',
                name: '最小值'
            });
        }
        if (this.props.options.markMaxPoint) {
            markPoint.data.push({
                type: 'max',
                name: '最大值'
            });
        }
        const markLine = {
            label: {
                formatter: params => Charts.format(this.props.chart, params.value)
            },
            data: []
        };
        if (this.props.options.markAvgPoint) {
            markLine.data.push({
                type: 'average',
                name: '平均值'
            });
        }
        let rPercnet = 7;
        switch (this.props.widthInColumns) {
            case 1:
                rPercnet = 20;
                break;
            case 2:
                rPercnet = 10;
                break;
            case 3:
                rPercnet = 7;
                break;
            default:
                rPercnet = 7;
                break;

        }
        if (!this.props.options.markAvgPoint) {
            rPercnet = 7;
        }
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        //trigger: 'axis',
                        axisPointer: {
                            // Use axis to trigger tooltip
                            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                        }
                    },
                    label: {
                        show: this.props.options.stack ? false : true,
                        position: 'top',
                        formatter: params => Charts.format(this.props.chart, params.value)
                    },
                    grid: {
                        left: '7%',
                        right: `${rPercnet}%`,
                        bottom: '3%',
                        containLabel: true
                    },
                    legend: {
                        data: this.props.data.dimensions,
                        show: true,
                        //selectedMode: 'single'
                    },
                    xAxis: {
                        type: 'category',
                        data: this.props.data.xAxis,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        nameTextStyle: {
                            color: '#485465'
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                        axisLabel: {
                            formatter: function (value, index) {
                                const n = Number.parseFloat(value);
                                let s = n > 10000 ? (n / 10000).toFixed(2) + "万" : n.toString();
                                if (s.endsWith('.00万')) {
                                    s = (n / 10000).toFixed(0) + "万"
                                }
                                return s;
                            }
                        },
                        axisTick: {
                            length: 0,
                            lineStyle: {
                                color: '#485465',
                                width: 0
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F5F7F8'
                            }
                        },
                    },
                    series: this.props.data.values?.map(item => {
                        return {
                            name: item.name,
                            type: 'bar',
                            stack: this.props.options.stack ? 'value' : undefined,
                            emphasis: {
                                focus: 'self'
                            },
                            data: item.value,
                            barMaxWidth: this.props.options.maxWidth > 0 ? this.props.options.maxWidth : 40,
                            markPoint,
                            markLine,
                        }
                    })
                }} />
        </div>;
    }
}

class PercentBarChart extends React.Component {

    render() {
        //console.log(this.props.data);
        let rPercnet = 7;
        switch (this.props.widthInColumns) {
            case 1:
                rPercnet = 20;
                break;
            case 2:
                rPercnet = 10;
                break;
            case 3:
                rPercnet = 7;
                break;
            default:
                rPercnet = 7;
                break;

        }
        if (!this.props.options.markAvgPoint) {
            rPercnet = 7;
        }

        let values = [];
        if (this.props.data?.values) {
            const sumVals = [];
            for (let i = 0; i < this.props.data.xAxis.length; i++) {
                sumVals.push(0);
                for (const item of this.props.data.values) {
                    const v = Number.parseFloat(item.value[i]);
                    sumVals[i] += Number.isNaN(v) ? 0 : v;
                }
            }
            values = this.props.data.values.map(item => {

                return {
                    name: item.name,
                    value: item.value.map((v, index) => v / sumVals[index] * 100)
                }
            });
            //console.log(values, this.props.data);
        }
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        //trigger: 'axis',
                        axisPointer: {
                            // Use axis to trigger tooltip
                            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                        },
                        borderWidth: 1,
                        className: 'site-chart-tooltip',
                        formatter: params => {
                            //console.log(params);
                            if (params.dataIndex >= 0) {
                                const labels = [];
                                for (let i = values.length - 1; i >= 0; i--) {
                                    const item = values[i];
                                    const absItem = this.props.data.values[i];
                                    labels.push({
                                        name: item.name,
                                        value: item.value[params.dataIndex],
                                        absVal: absItem?.value[params.dataIndex]
                                    });
                                }
                                //console.log(labels);
                                const node = document.createElement('div');
                                ReactDOM.render(<div style={{ width: 260 }}>
                                    <Row>
                                        <Col>● {params.name}</Col>
                                    </Row>
                                    {labels.filter(it => it.value !== undefined).map((it) => <Row
                                        style={{
                                            color: it.name === params.seriesName && params.color,
                                            fontSize: 13
                                        }}
                                    >
                                        <Col flex='auto'>{it.name}</Col>
                                        <Col flex='80px' style={{ textAlign: 'right' }}>
                                            <code>
                                                {Charts.format(this.props.chart, it.absVal)}
                                            </code>
                                        </Col>
                                        <Col flex='80px' style={{ textAlign: 'right' }}>
                                            <code>{`${it.value?.toFixed(2)}%`}</code>
                                        </Col>
                                    </Row>)}
                                </div>, node);
                                return node.innerHTML;
                            }
                            return `${params.name} / ${params.seriesName}: ${params.value.toFixed(2)}%`;
                        },
                    },
                    label: {
                        show: false,
                        position: 'top',
                        formatter: params => `${params.value.toFixed(2)}%`
                    },
                    grid: {
                        left: '7%',
                        right: `${rPercnet}%`,
                        bottom: '3%',
                        containLabel: true
                    },
                    legend: {
                        data: this.props.data.dimensions,
                        show: true,
                        //selectedMode: 'single'
                    },
                    xAxis: {
                        type: 'category',
                        data: this.props.data.xAxis,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        nameTextStyle: {
                            color: '#485465'
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                        axisLabel: {
                            formatter: function (value) {
                                const n = Number.parseFloat(value);
                                return `${Number.isNaN(n) ? '0' : n.toFixed(2)}%`;
                            }
                        },
                        axisTick: {
                            length: 0,
                            lineStyle: {
                                color: '#485465',
                                width: 0
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F5F7F8'
                            }
                        },
                        min: 0,
                        max: 100
                    },
                    series: values.map(item => {
                        return {
                            name: item.name,
                            type: 'bar',
                            stack: 'value',
                            emphasis: {
                                focus: 'self'
                            },
                            data: item.value,
                            barMaxWidth: this.props.options.maxWidth > 0 ? this.props.options.maxWidth : 40,
                        }
                    })
                }} />
        </div>;
    }
}

class StripeChart extends React.Component {

    render() {
        //console.log(this.props.data);
        const markPoint = {
            label: {
                formatter: params => Charts.format(this.props.chart, params.value)
            },
            data: []
        };
        if (this.props.options.markMinPoint) {
            markPoint.data.push({
                type: 'min',
                name: '最小值'
            });
        }
        if (this.props.options.markMaxPoint) {
            markPoint.data.push({
                type: 'max',
                name: '最大值'
            });
        }
        const markLine = {
            label: {
                formatter: params => Charts.format(this.props.chart, params.value)
            },
            data: []
        };
        if (this.props.options.markAvgPoint) {
            markLine.data.push({
                type: 'average',
                name: '平均值'
            });
        }
        let rPercnet = 7;
        switch (this.props.widthInColumns) {
            case 1:
                rPercnet = 20;
                break;
            case 2:
                rPercnet = 10;
                break;
            case 3:
                rPercnet = 7;
                break;
            default:
                rPercnet = 7;
                break;

        }
        if (!this.props.options.markAvgPoint) {
            rPercnet = 7;
        }
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        //trigger: 'axis',
                        axisPointer: {
                            // Use axis to trigger tooltip
                            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                        }
                    },
                    label: {
                        show: this.props.options.stack ? false : true,
                        position: 'right',
                        formatter: params => Charts.format(this.props.chart, params.value)
                    },
                    grid: {
                        left: '7%',
                        right: `${rPercnet}%`,
                        bottom: '3%',
                        containLabel: true
                    },
                    legend: {
                        data: this.props.data.dimensions,
                        show: true
                    },
                    xAxis: {
                        type: 'value',
                        nameTextStyle: {
                            color: '#485465'
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                        axisLabel: {
                            formatter: function (value, index) {
                                const n = Number.parseFloat(value);
                                let s = n > 10000 ? (n / 10000).toFixed(2) + "万" : n.toString();
                                if (s.endsWith('.00万')) {
                                    s = (n / 10000).toFixed(0) + "万"
                                }
                                return s;
                            }
                        },
                        axisTick: {
                            length: 0,
                            lineStyle: {
                                color: '#485465',
                                width: 0
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F5F7F8'
                            }
                        },
                    },
                    yAxis: {
                        type: 'category',
                        data: this.props.data.xAxis,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                    },
                    series: this.props.data.values?.map(item => {
                        return {
                            name: item.name,
                            type: 'bar',
                            stack: this.props.options.stack ? 'value' : undefined,
                            emphasis: {
                                focus: 'self'
                            },
                            data: item.value,
                            barMaxWidth: this.props.options.maxWidth > 0 ? this.props.options.maxWidth : 40,
                            markPoint,
                            markLine,
                        }
                    })
                }} />
        </div>;
    }
}

class PercentStripeChart extends React.Component {

    render() {
        //console.log(this.props.data);
        let rPercnet = 7;
        switch (this.props.widthInColumns) {
            case 1:
                rPercnet = 20;
                break;
            case 2:
                rPercnet = 10;
                break;
            case 3:
                rPercnet = 7;
                break;
            default:
                rPercnet = 7;
                break;

        }
        if (!this.props.options.markAvgPoint) {
            rPercnet = 7;
        }

        let values = [];
        if (this.props.data?.values) {
            const sumVals = [];
            for (let i = 0; i < this.props.data.xAxis.length; i++) {
                sumVals.push(0);
                for (const item of this.props.data.values) {
                    const v = Number.parseFloat(item.value[i]);
                    sumVals[i] += Number.isNaN(v) ? 0 : v;
                }
            }
            values = this.props.data.values.map(item => {

                return {
                    name: item.name,
                    value: item.value.map((v, index) => v / sumVals[index] * 100)
                }
            });
            //console.log(values, this.props.data);
        }
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        //trigger: 'axis',
                        axisPointer: {
                            // Use axis to trigger tooltip
                            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                        },
                        formatter: params => {
                            //console.log(params);
                            if (params.dataIndex >= 0) {
                                const labels = [];
                                for (let i = values.length - 1; i >= 0; i--) {
                                    const item = values[i];
                                    const absItem = this.props.data.values[i];
                                    labels.push({
                                        name: item.name,
                                        value: item.value[params.dataIndex],
                                        absVal: absItem?.value[params.dataIndex]
                                    });
                                }
                                //console.log(labels);
                                const node = document.createElement('div');
                                ReactDOM.render(<div style={{ width: 300 }}>
                                    <Row>
                                        <Col>● {params.name}</Col>
                                    </Row>
                                    {labels.filter(it => it.value !== undefined).map((it) => <Row
                                        style={{
                                            color: it.name === params.seriesName && params.color,
                                            fontSize: 12
                                        }}
                                    >
                                        <Col flex='auto'>{
                                            isNotEmpty(it.name) && it.name.length > 10
                                                ? it.name.substring(0, 10) + "..."
                                                : it.name
                                        }</Col>
                                        <Col flex='80px' style={{ textAlign: 'right' }}>
                                            <code>
                                                {Charts.format(this.props.chart, it.absVal)}
                                            </code>
                                        </Col>
                                        <Col flex='80px' style={{ textAlign: 'right' }}>
                                            <code>{`${it.value?.toFixed(2)}%`}</code>
                                        </Col>
                                    </Row>)}
                                </div>, node);
                                return node.innerHTML;
                            }
                            return `${params.name} / ${params.seriesName}: ${params.value.toFixed(2)}%`;
                        },
                    },
                    label: {
                        show: false,
                        position: 'top',
                        formatter: params => `${params.value.toFixed(2)}%`
                    },
                    grid: {
                        left: '7%',
                        right: `${rPercnet}%`,
                        bottom: '3%',
                        containLabel: true
                    },
                    legend: {
                        data: this.props.data.dimensions,
                        show: true
                    },
                    xAxis: {
                        type: 'value',
                        nameTextStyle: {
                            color: '#485465'
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                        axisLabel: {
                            formatter: function (value) {
                                const n = Number.parseFloat(value);
                                return `${Number.isNaN(n) ? '0' : n.toFixed(2)}%`;
                            }
                        },
                        axisTick: {
                            length: 0,
                            lineStyle: {
                                color: '#485465',
                                width: 0
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F5F7F8'
                            }
                        },
                        min: 0,
                        max: 100
                    },
                    yAxis: {
                        type: 'category',
                        data: this.props.data.xAxis,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        }
                    },
                    series: values.map(item => {
                        return {
                            name: item.name,
                            type: 'bar',
                            stack: 'value',
                            emphasis: {
                                focus: 'self'
                            },
                            data: item.value,
                            barMaxWidth: this.props.options.maxWidth > 0 ? this.props.options.maxWidth : 40,
                        }
                    })
                }} />
        </div>;
    }
}

class LineChart extends React.Component {
    render() {
        const markPoint = {
            label: {
                formatter: params => Charts.format(this.props.chart, params.value)
            },
            data: []
        };
        if (this.props.options.markMinPoint) {
            markPoint.data.push({
                type: 'min',
                name: '最小值'
            });
        }
        if (this.props.options.markMaxPoint) {
            markPoint.data.push({
                type: 'max',
                name: '最大值'
            });
        }
        const markLine = {
            label: {
                formatter: params => Charts.format(this.props.chart, params.value)
            },
            precision: 4,
            data: []
        };
        if (this.props.options.markAvgPoint) {
            markLine.data.push({
                type: 'average',
                name: '平均值'
            });
        }
        // 7 10 20
        let rPercnet = 7;
        switch (this.props.widthInColumns) {
            case 1:
                rPercnet = 20;
                break;
            case 2:
                rPercnet = 10;
                break;
            case 3:
                rPercnet = 7;
                break;
            default:
                rPercnet = 7;
                break;

        }
        if (!this.props.options.markAvgPoint) {
            rPercnet = 7;
        }
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        //show: false,
                        trigger: 'axis',
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        formatter: params => {
                            const items = params.map(p => {
                                return {
                                    name: p.seriesName,
                                    value: p.value,
                                    color: p.color,
                                };
                            }).sort((a, b) => {
                                if (a.value > b.value) {
                                    return -1;
                                } else if (a.value < b.value) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            });

                            //console.log(params);
                            const node = document.createElement('div');
                            ReactDOM.render(<>
                                <Row justify='center'>
                                    <Col>
                                        <span style={{ fontWeight: 500, color: 'white' }}>
                                            {params[0].name}
                                        </span>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: '3px', color: 'white', borderBlockColor: 'white' }} />
                                {items.map(it => <Row style={{ color: it.color }}>
                                    <Col>{it.name}：</Col>
                                    <Col>{Charts.format(this, it.value)}</Col>
                                </Row>)}
                            </>, node);
                            return node.innerHTML;
                        },
                    },
                    toolbox: {
                        show: false,
                        feature: {
                            dataZoom: {
                                yAxisIndex: 'none'
                            },
                            dataView: { readOnly: false },
                            magicType: { type: ['line', 'bar'] },
                            restore: {},
                        }
                    },
                    legend: {
                        //show: false,
                        data: this.props.data.dimensions,
                        type: 'scroll'
                    },
                    grid: {
                        left: '7%',
                        right: `${rPercnet}%`,
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                        boundaryGap: false,
                        data: this.props.data.xAxis
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8c8c8c'
                            }
                        },
                        axisLabel: {
                            formatter: function (value, index) {
                                const n = Number.parseFloat(value);
                                let s = n > 10000 ? (n / 10000).toFixed(2) + "万" : n.toString();
                                if (s.endsWith('.00万')) {
                                    s = (n / 10000).toFixed(0) + "万"
                                }
                                return s;
                            }
                        },
                        axisTick: {
                            length: 0,
                            lineStyle: {
                                color: '#485465',
                                width: 0
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#F5F7F8'
                            }
                        },
                    },
                    series: this.props.data.values?.map(item => {
                        return {
                            //symbol: 'none',
                            smooth: (this.props.options.smooth === undefined) ? true : this.props.options.smooth,
                            name: item.name,
                            type: 'line',
                            stack: this.props.options.stack ? 'value' : undefined,
                            data: item.value,
                            markPoint,
                            markLine
                        }
                    })
                }} />
        </div>;
    }
}

class PieChart extends React.Component {
    render() {
        //console.log(this.props.data);
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        trigger: 'item',
                        formatter: params => `${params.data.name}:${Charts.format(this.props.chart, params.value)}`
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left'
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: '50%',
                            data: this.props.data,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }} />
        </div>;
    }
}

class CardChart extends React.Component {
    render() {
        let data = [];
        if (this.props.data instanceof Array) {
            data = this.props.data;
        }
        //this.props.options.
        let atomicWidth = '100%';
        let colsInline = 0
        switch (this.props.widthInColumns) {
            case 1:
                atomicWidth = '50%';
                colsInline = 2;
                break
            case 2:
                atomicWidth = '25%';
                colsInline = 4;
                break;
            case 3:
                atomicWidth = '15%';
                colsInline = 6;
                break;
            case 4:
            default:
                colsInline = 8;
                atomicWidth = '12.5%';
                break;
        }
        const rows = [];
        let k = 0;
        for (let i = 0; i < data.length / colsInline; i++) {
            const cols = [];
            for (let j = 0; j < colsInline; j++) {
                if (k < data.length) {
                    const item = data[k++];
                    cols.push(<Col
                        flex={atomicWidth}
                        style={{
                            padding: '5px',
                            borderBottom: '1px solid rgba(0,0,0,.1)',
                            borderRight: j < colsInline - 1 ? '1px solid rgba(0,0,0,.1)' : undefined
                        }}
                    >
                        <Statistic
                            formatter={value => Charts.format(this.props.chart, value)}
                            title={item.name}
                            value={item.value}
                            prefix={this.props.options.prefix}
                            suffix={this.props.options.suffix}
                        />
                    </Col>);
                } else {
                    cols.push(<Col flex={atomicWidth}></Col>)
                }
            }
            rows.push(<Row justify='center' style={{ margin: '0 0 10px 0' }}>
                {data.length === 1
                    ? <Col>
                        <Statistic
                            formatter={value => Charts.format(this.props.chart, value)}
                            title={data[0].name}
                            value={data[0].value}
                            prefix={this.props.options.prefix}
                            suffix={this.props.options.suffix}
                        />
                    </Col>
                    : cols}
            </Row>);
        }
        return <div
            style={{
                width: '100%',
                height: this.props.height,
                overflowY: 'auto',
                padding: '10px'
            }}
        >
            {rows}
        </div>;
    }
}

function FlattenTable(props) {

    return <table
        style={{
            //width: 
            whiteSpace: 'nowrap'
        }}
    >
        <thead
            style={{
                display: 'table',
                //tableLayout: 'fixed',
                width: '100%',
                overflowX: 'auto'
            }}
        >
            <tr
                style={{
                    borderBottom: '1px solid #1890ff'
                }}
            >
                {props.cols.map(col => <th
                    key={col.name}
                    style={{
                        minWidth: 70,
                        padding: 5,
                    }}
                >
                    <span style={{ fontWeight: 500, fontSize: 12 }}>{col.title}</span>
                </th>)}
            </tr>
        </thead>
        <tbody
            style={{
                display: 'block',
                //tableLayout: 'fixed',
                width: '100%',
                height: props.height - 70,
                overflowY: 'auto',
                overflowX: 'auto'
            }}
        >
            {props.rows.map((row, index) => <tr
                style={{
                    display: 'table',
                    tableLayout: 'fixed',
                    width: '100%',
                    backgroundColor: (index % 2 == 1) && 'rgba(77, 136, 255, 0.05)'
                }}
            >
                {props.cols.map(col => <td
                    style={{
                        minWidth: 50,
                        padding: 5,
                    }}
                >
                    <span style={{ fontSize: 12, fontWeight: 500 }}>{ifEmpty(row[col.name], '')}</span>
                </td>)}
            </tr>)}
        </tbody>
    </table>;
}

class FlattenTableChart extends React.Component {
    constructor() {
        super();
        this.state = {
            colsWidth: [],
            cols: [],
            colsFmt: [],
        }
        this.colsWidth = [];
        this.dirty = false;
        this.container = React.createRef();
        this.cache = new CellMeasurerCache({
            defaultWidth: 100,
            minWidth: 75,
            fixedHeight: true
        });
        this.handler = React.createRef();
    }

    componentDidMount() {
        let { cols, colsFmt } = this.props.data;
        if (!(cols instanceof Array)) {
            cols = [];
        }
        if (!(colsFmt instanceof Array)) {
            colsFmt = [];
        }
        this.setState({ cols, colsFmt });
    }

    render() {
        let { rows } = this.props.data;
        let { cols, colsFmt } = this.state;
        if (!(rows instanceof Array)) {
            rows = [];
        } else {
            const lines = [];
            for (const row of rows) {
                const line = [];
                for (const col of cols) {
                    line.push(row[col.name]);
                }
                lines.push(line);
            }
            rows = lines;
        }

        //console.log(cols);
        return <div
            ref={this.container}
            style={{
                width: '100%',
                height: this.props.height,
                overflowY: 'hidden',
                overflowX: 'hidden',
                padding: '10px'
            }}
        >
            <HotTable
                height={this.props.height - 20}
                data={rows}
                //rowHeaders
                //colHeaders
                colHeaders={cols.map(col => col.title)}
                columns={colsFmt}
                language="zh-CN"
                manualColumnResize
                manualRowResize
                columnSorting={true}
                filters={true}
                manualColumnMove={true}
                manualColumnFreeze={true}
                dropdownMenu={{
                    items: {
                        setFormat: {
                            name: '格式',
                            key: 'format',
                            submenu: {
                                items: [
                                    {
                                        key: 'format:1',
                                        name: '原始数据',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            // result.columnsFmt[col].numericFormat = undefined;
                                            colsFmt[col].numericFormat = undefined;
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:2',
                                        name: '整数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0,00',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:3',
                                        name: '保留1位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0.0',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:4',
                                        name: '保留2位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0.00',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:5',
                                        name: '保留3位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0.000',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:6',
                                        name: '保留4位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0.0000',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:7',
                                        name: '百分比1位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0.0%',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }, {
                                        key: 'format:8',
                                        name: '百分比2位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            colsFmt[col].numericFormat = {
                                                pattern: '0.00%',
                                                culture: 'zh-CN'
                                            };
                                            this.setState({ colsFmt: [...colsFmt] });
                                        }
                                    }
                                ]
                            }
                        },
                        hsep5: '---------',
                        filter1: 'filter_by_condition',
                        filter2: 'filter_operators',
                        filter3: 'filter_by_condition2',
                        filter4: 'filter_by_value',
                        filter5: 'filter_action_bar',

                    }
                }}
                licenseKey="non-commercial-and-evaluation"
            />
        </div>;
    }
}

class TreeMapChart extends React.Component {

    render() {
        //console.log(this.props.data);
        let levels = undefined;
        //if (this.props.data !== undefined && this.props.data.length === 1) {
        levels = [
            {

                itemStyle: {
                    borderWidth: 2,
                    gapWidth: 1
                }
            }, {
                color: this.props.data?.length === 1 && colors3,
                colorMappingBy: this.props.data?.length === 1 && 'name',
                itemStyle: {
                    borderWidth: 1,
                    gapWidth: 1
                }
            }
        ];
        //}
        //console.log(levels, this.props.data);
        return <div
            style={{
                width: '96%',
                height: this.props.height,
                //border
            }}
        >
            <ReactEcharts
                style={{ height: this.props.height }}
                option={{
                    color: colors3,
                    tooltip: {
                        trigger: 'item',
                        formatter: params => `${params.data.name}:${Charts.format(this.props.chart, params.value)}`
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        //show: false,
                    },
                    series: [
                        {
                            type: 'treemap',
                            breadcrumb: {
                                show: true,
                            },
                            roam: false,
                            radius: '50%',
                            data: this.props.data,
                            levels,

                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }} />
        </div>;
    }
}

// isSelected
// readOnly
// onClick()
// onDelete()
// onShowParams()
// onRefresh()
// onParamChanage(name, value)
// placeholders
// chart
// provided
class ChartBundle extends React.Component {

    constructor() {
        super();
        this.state = {
            unclickable: false,
        };
    }

    render() {
        const {
            isSelected,
            onClick,
            onDelete,
            //onShowParams,
            onShowDownloadModal,
            onRefresh,
            onParamChanage,
            chart,
            placeholders,
            provided } = this.props;
        let chartNode = undefined;
        switch (chart.chartKind) {
            case 'BLOCK':
                chartNode = <BlockChart
                    height={chart.height - 10}
                    selected={isSelected}
                />;
                break;
            case 'BAR_CHART':
                chartNode = <BarChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'PERCENT_BAR_CHART':
                chartNode = <PercentBarChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'STRIPE_CHART':
                chartNode = <StripeChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'PERCENT_STRIPE_CHART': //PercentStripeChart
                chartNode = <PercentStripeChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'LINE_CHART':
                chartNode = <LineChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    widthInColumns={chart.widthInColumns}
                    options={chart.options}
                />;
                break;
            case 'PIE_CHART':
                chartNode = <PieChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'TREE_MAP_CHART':
                chartNode = <TreeMapChart
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'CARD_CHART':
                chartNode = <CardChart
                    height={chart.height - 10}
                    widthInColumns={chart.widthInColumns}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            case 'FLATTEN_TABLE':
                chartNode = <FlattenTableChart
                    //width={width}
                    widthInColumns={chart.widthInColumns}
                    height={chart.height - 10}
                    selected={isSelected}
                    data={chart.data}
                    options={chart.options}
                />;
                break;
            default:
                return <></>;
        }
        if (isNotEmpty(chart.fatal) && chart.fatal !== false) {
            chartNode = <div style={{ height: chart.height - 10, overflowY: 'auto' }}>
                <Result
                    status="error"
                    title={`数据源错误`}
                    subTitle={chart.fatal}
                    extra={
                        <Button type="primary" key="console" onClick={onRefresh}>
                            重试
                        </Button>
                    }
                    onClick={onClick}
                />
            </div>;
        } else if (chartNode && chart.chartKind !== 'BLOCK' && (isEmpty(chart.data) || JSON.stringify(chart.data) === '{}')) {
            chartNode = <div style={{ height: chart.height - 10 }}>
                <Result
                    status="warning"
                    title="数据未加载"
                    extra={
                        <Button type="primary" key="console" onClick={onRefresh}>
                            加载数据
                        </Button>
                    }
                    onClick={onClick}
                />
            </div>;
        }

        const visible = chart.visible ? chart.visible : {};

        const coreNode = <><Row style={{ padding: '0 5px 0 5px' }}>
            {isNotEmpty(chart.name) && <Col style={{ alignSelf: 'center', padding: '3px' }}>
                <span style={{ fontSize: 12, fontWeight: 'bold' }}>{`<${chart.name}>`}</span>
            </Col>}
            {placeholders
                .filter(param => chart.widthInColumns >= 2 && isTimeFormat(param.format))
                .filter(param => !visible[param.name])
                .map((param, index) => <>
                    <Col flex={index === 0 && '74px'} style={{ alignSelf: 'center', textAlign: 'right' }}>
                        <span style={{ fontSize: 12, color: 'gray' }}>{param.name} : </span>
                    </Col>
                    <Col flex={`${param.format === 'DATE_RANGE' ? 240 : 140}px`} style={{ padding: '3px' }}>
                        <PlaceholderInput
                            md={this.props.md}
                            disabled={chart.updating}
                            placeholder={param}
                            value={chart.params[param.name]}
                            onChange={value => onParamChanage(param.name, value, this.props.readOnly)}
                            onOpenChange={(open) => {
                                //console.log('open', open);
                                this.setState({ unclickable: open });
                            }}
                        />
                    </Col>
                </>)}
            <Col flex='auto'></Col>
            {(!this.props.readOnly || chart.chartKind !== 'BLOCK') && <>
                {this.props.onCopy && <Col>
                    <Button
                        size='small'
                        type='link'
                        disabled={chart.chartKind === 'BLOCK'}
                        icon={<CopyOutlined />}
                        onClick={() => this.props.onCopy(chart)}
                    />
                </Col>}
                {!chart.updating && <Col>
                    <Button
                        size='small'
                        type='link'
                        disabled={chart.chartKind === 'BLOCK'}
                        icon={<DownloadOutlined />}
                        onClick={() => onShowDownloadModal(chart)}
                    />
                </Col>}
                <Col>
                    <Button
                        size='small'
                        type='link'
                        disabled={chart.chartKind === 'BLOCK'}
                        icon={chart.updating ? <PauseOutlined /> : <ReloadOutlined />}
                        onClick={onRefresh}
                    />
                </Col>
            </>}
            {!this.props.readOnly && <Col>
                <Popconfirm
                    title='是否删除指定的图表?'
                    onConfirm={onDelete}
                    disabled={chart.updating}
                >
                    <Button
                        size='small'
                        type='link'
                        danger
                        disabled={chart.updating}
                        icon={<DeleteOutlined />}
                    ></Button>
                </Popconfirm>
            </Col>}
        </Row>
            {/*chart.showParams &&*/ placeholders
                .filter(param => chart.widthInColumns < 2 || !isTimeFormat(param.format))
                .filter(param => !visible[param.name])
                .map(param => <>
                    <Row>
                        <Col flex='80px' style={{ textAlign: 'right', padding: '2px 0px 0px 0px', alignSelf: 'center' }}>
                            {isEmpty(param.column) && <span style={{ fontSize: 12, color: 'red' }}>*</span>}
                            <span style={{ fontSize: 12, color: 'gray' }}>{param.name} : </span>
                        </Col>
                        <Col flex={chart.widthInColumns === 1 ? '70%' : '80%'} style={{ padding: '3px' }}>
                            <PlaceholderFlattenInput
                                md={this.props.md}
                                disabled={chart.updating}
                                placeholder={param}
                                value={chart.params[param.name]}
                                onChange={value => onParamChanage(param.name, value)}
                            />
                        </Col>
                    </Row>
                </>)}
            <Row>
                <Col flex='100%' style={{ alignSelf: 'center', alignItems: 'center' }}>
                    {chart.updating
                        ? <div
                            style={{
                                width: '90%',
                                height: chart.height,
                                alignSelf: 'center',
                                textAlign: 'center',
                                padding: '20px'
                            }}>
                            <Progress
                                size='small'
                                percent={chart.fakePercent?.toFixed(2)}
                            />
                        </div>
                        : chartNode}
                </Col>
            </Row>
        </>;
        if (this.props.readOnly) {
            return <div style={{
                margin: '10px 10px 0 0',
                border: '1px solid rgb(221, 234, 255)',
                borderRadius: '4px'
            }}>
                {coreNode}
            </div>;
        }

        let border = '';
        if (isSelected) {
            border = '1px solid #1890ff';
        } else {
            border = '1px solid rgb(221, 234, 255)';
        }
        let mouseEvents = {}
        if (!this.props.readOnly) {
            mouseEvents.onMouseDown = e => this.props.onResizeStart('bottom', this.props.chart, e);
            mouseEvents.onMouseLeave = e => this.props.onResizeCancel('bottom', this.props.chart, e);
            mouseEvents.onMouseEnter = e => this.props.onResizePrepare('bottom', this.props.chart, e);
        }
        return <div
            //onMouseDown={onClick}
            onClick={this.state.unclickable ? undefined : onClick}
            key={chart.key}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}

        >
            <div
                style={{ border }}>
                {coreNode}
            </div>
            <div
                style={{ cursor: 'row-resize', height: 6 }}
                {...mouseEvents}
            >
            </div>
        </div>;
    }
}

function DataPreviewModal(props) {
    let [cols, setCols] = useState([]);
    let [colsFmt, setColsFmt] = useState([]);
    let [rows, setRows] = useState([]);

    const { chart, visible, title, onClose, mappedProjection } = props;

    useEffect(() => {
        switch (chart.chartKind) {
            case 'FLATTEN_TABLE': {
                cols = chart.data.cols.map(col => col.title);
                setCols(cols);
                colsFmt = [...chart.data.colsFmt];
                setColsFmt(colsFmt);
                rows = chart.data.rows;
                if (!(rows instanceof Array)) {
                    rows = [];
                } else {
                    const lines = [];
                    for (const row of rows) {
                        const line = [];
                        for (const col of chart.data.cols) {
                            line.push(row[col.name]);
                        }
                        lines.push(line);
                    }
                    rows = lines;
                }
                setRows(rows);
            } break;
            default: {
                console.log(chart);
                const keys = [];
                cols = [];
                colsFmt = [];
                for (const p of chart.dimensions) {
                    keys.push(p.name);
                    cols.push(mappedProjection[chart.templateId][p.name]?.desc);
                    colsFmt.push({ type: 'text', readOnly: false });
                }
                for (const p of chart.legends) {
                    keys.push(p.name);
                    cols.push(mappedProjection[chart.templateId][p.name]?.desc);
                    colsFmt.push({ type: 'text', readOnly: false });
                }
                for (const p of chart.indicators) {
                    keys.push(p.name);
                    cols.push(mappedProjection[chart.templateId][p.name]?.desc);
                    colsFmt.push({ type: 'numeric', readOnly: false });
                }
                for (const p of chart.calculating) {
                    keys.push(p.name);
                    cols.push(chart.calculating.find(calc => calc.key === p.name)?.name);
                    colsFmt.push({ type: 'numeric', readOnly: false });
                }
                setColsFmt(colsFmt);
                setCols(cols);

                rows = [];
                for (const row of (chart.originalData instanceof Array ? chart.originalData : [])) {
                    const line = [];
                    for (const col of keys) {
                        line.push(row[col]);
                    }
                    rows.push(line);
                }
                setRows(rows);
            } break;
        }
    }, []);

    return <Modal
        visible={visible}
        title={title}
        maskClosable={false}
        width={700}
        onOk={onClose}
        onCancel={onClose}
        footer={<Row>
            <Col flex='auto'></Col>
            <Col>
                <Space>
                    <Button
                        size='small'
                        onClick={() => {
                            const headers = cols.join('\t') + '\n';
                            const content = rows.map(row => row.join('\t')).join('\n');
                            if (copy(headers + content, { format: 'text/plain' })) {
                                message.success('复制成功');
                            }
                        }}
                    >复制数据</Button>
                    <Button
                        size='small'
                        onClick={onClose}
                        type='primary'
                    >确定</Button>
                </Space>
            </Col>
        </Row>}
    >
        <Row>
            <Col flex='100%' style={{ overflowX: 700 }}>
                <HotTable
                    height={500}
                    data={rows}
                    colHeaders={cols}
                    columns={colsFmt}
                    language="zh-CN"
                    manualColumnResize
                    manualRowResize
                    columnSorting={true}
                    filters={true}
                    manualColumnMove={true}
                    manualColumnFreeze={true}
                    dropdownMenu={{
                        items: {
                            setFormat: {
                                name: '格式',
                                key: 'format',
                                submenu: {
                                    items: [
                                        {
                                            key: 'format:1',
                                            name: '原始数据',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                // result.columnsFmt[col].numericFormat = undefined;
                                                colsFmt[col].numericFormat = undefined;
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:2',
                                            name: '整数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0,00',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:3',
                                            name: '保留1位小数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0.0',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:4',
                                            name: '保留2位小数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0.00',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:5',
                                            name: '保留3位小数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0.000',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:6',
                                            name: '保留4位小数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0.0000',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:7',
                                            name: '百分比1位小数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0.0%',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }, {
                                            key: 'format:8',
                                            name: '百分比2位小数',
                                            callback: (key, options) => {
                                                const col = options[0].start.col;
                                                colsFmt[col].numericFormat = {
                                                    pattern: '0.00%',
                                                    culture: 'zh-CN'
                                                };
                                                setColsFmt([...colsFmt]);
                                            }
                                        }
                                    ]
                                }
                            },
                            hsep5: '---------',
                            filter1: 'filter_by_condition',
                            filter2: 'filter_operators',
                            filter3: 'filter_by_condition2',
                            filter4: 'filter_by_value',
                            filter5: 'filter_action_bar',

                        }
                    }}
                    licenseKey="non-commercial-and-evaluation"
                />
            </Col>
        </Row>
    </Modal>;
}

class OptionsBundle extends React.Component {

    constructor() {
        super();
        this.state = {

        };
    }

    render() {
        const { chart, options } = this.props;
        switch (chart.chartKind) {
            case 'BLOCK':
                return <></>;
            case 'BAR_CHART':
            case 'STRIPE_CHART':
                return this.renderBarOptions(options);
            case 'LINE_CHART':
                return this.renderLineOptions(options);
            case 'PIE_CHART':
                return this.renderPieOptions(options);
            case 'CARD_CHART':
                return this.renderCardOptions(options);
            case 'TREE_MAP_CHART':
            // TODO: 
            default:
                return <></>;
        }
    }

    renderBarOptions(options) {
        return <>
            {this.renderTitle('单柱最大宽度')}
            <Row>
                <Col flex='100%'>
                    <InputNumber
                        style={{ width: '100%' }}
                        size='small'
                        value={options.maxWidth}
                        defaultValue={40}
                        min={10}
                        max={80}
                        addonAfter='px'
                        onChange={value => {
                            options.maxWidth = value;
                            this.props.onChange(options);
                        }}
                    />
                </Col>
            </Row>
            {this.renderMarkPoint(options)}
            {this.renderTitle('图表切换')}
            <Row>
                <Col flex='100%'>
                    <Radio.Group
                        style={{ width: '100%' }}
                        size='small'
                        defaultValue={'bar'}
                        value={options.stack ? 'stack' : 'bar'}
                        onChange={({ target: { value } }) => {
                            options.stack = (value === 'stack');
                            this.props.onChange(options);
                        }}
                    >
                        <Radio size='small' value='bar'>
                            <span style={{ fontSize: 12 }}>柱状图</span>
                        </Radio>
                        <Radio size='small' value='stack'>
                            <span style={{ fontSize: 12 }}>堆积柱状图</span>
                        </Radio>
                    </Radio.Group>
                </Col>
            </Row>
        </>;
    }

    renderLineOptions(options) {
        return <>
            {this.renderTitle('平滑度')}
            <Row>
                <Col flex='100%'>
                    <Switch
                        defaultChecked={true}
                        size='small'
                        checkedChildren='平滑'
                        unCheckedChildren='折线'
                        checked={options.smooth}
                        onChange={checked => {
                            options.smooth = checked;
                            this.props.onChange(options);
                        }}
                        title='是否平滑'
                    />
                </Col>
            </Row>
            {this.renderMarkPoint(options)}
            {this.renderTitle('图表切换')}
            <Row>
                <Col flex='100%'>
                    <Radio.Group
                        style={{ width: '100%' }}
                        size='small'
                        defaultValue={'bar'}
                        value={options.stack ? 'stack' : 'bar'}
                        onChange={({ target: { value } }) => {
                            options.stack = (value === 'stack');
                            this.props.onChange(options);
                        }}
                    >
                        <Radio size='small' value='bar'>
                            <span style={{ fontSize: 12 }}>折线图</span>
                        </Radio>
                        <Radio size='small' value='stack'>
                            <span style={{ fontSize: 12 }}>堆积折线图</span>
                        </Radio>
                    </Radio.Group>
                </Col>
            </Row>
        </>;
    }

    renderPieOptions() {
        return <></>;
    }

    renderCardOptions(options) {
        return <>
            {this.renderTitle('前缀')}
            <Row>
                <Col flex='100%'>
                    <Input
                        size='small'
                        style={{ width: '100%' }}
                        value={options.prefix}
                        onChange={({ target: { value } }) => {
                            options.prefix = value;
                            this.props.onChange(options);
                        }}
                    />
                </Col>
            </Row>
            {this.renderTitle('后缀')}
            <Row>
                <Col flex='100%'>
                    <Input
                        size='small'
                        style={{ width: '100%' }}
                        value={options.suffix}
                        onChange={({ target: { value } }) => {
                            options.suffix = value;
                            this.props.onChange(options);
                        }}
                    />
                </Col>
            </Row>
        </>;
    }

    renderMarkPoint(options) {
        return <>
            {this.renderTitle('标记点')}
            <Row>
                <Col flex='100%'>
                    <Checkbox
                        size='small'
                        defaultChecked={false}
                        checked={options.markMaxPoint}
                        onChange={({ target: { checked } }) => {
                            options.markMaxPoint = checked;
                            this.props.onChange(options);
                        }}
                    ><span style={{ fontSize: 12 }}>最大值</span></Checkbox>
                </Col>
            </Row>
            <Row>
                <Col flex='100%'>
                    <Checkbox
                        size='small'
                        defaultChecked={false}
                        checked={options.markMinPoint}
                        onChange={({ target: { checked } }) => {
                            options.markMinPoint = checked;
                            this.props.onChange(options);
                        }}
                    ><span style={{ fontSize: 12 }}>最小值</span></Checkbox>
                </Col>
            </Row>
            <Row>
                <Col flex='100%'>
                    <Checkbox
                        size='small'
                        defaultChecked={false}
                        checked={options.markAvgPoint}
                        onChange={({ target: { checked } }) => {
                            options.markAvgPoint = checked;
                            this.props.onChange(options);
                        }}
                    ><span style={{ fontSize: 12 }}>平均值</span></Checkbox>
                </Col>
            </Row>
        </>;
    }

    renderTitle(name) {
        return <Row>
            <Col>
                <span style={{ fontSize: 12, color: 'gray' }}>{name}</span>
            </Col>
        </Row>
    }
}

const Charts = {
    format(chart, input) {
        const value = Number.parseFloat(input);
        if (Number.isNaN(value)) {
            return input;
        }
        if (value > 10000) {
            return (value / 10000).toFixed(2) + '万';
        } else if (value === 0) {
            return 0;
        } else if (value < 1) {
            return value.toFixed(4);
        }
        return value;
    },

    isTreeMap(chart) { return chart.chartKind === 'TREE_MAP_CHART'; },
    isTable(chart) { return chart.chartKind.endsWith('_TABLE'); },

    processRows(chart, data, getTitle) {
        this.evaluateRows(chart, data);
        switch (chart.chartKind) {
            case 'BAR_CHART':
            case 'PERCENT_BAR_CHART':
            case 'STRIPE_CHART':
            case 'PERCENT_STRIPE_CHART':
            case 'LINE_CHART':

                if (chart.legends.length > 0) {
                    const xAxis = {};
                    for (let row of data) {
                        const key = chart.dimensions[0].name;
                        const dimVal = row[key] === undefined ? '未知' : row[key];
                        let items = xAxis[dimVal];
                        if (items === undefined) {
                            items = [];
                            xAxis[dimVal] = items;
                        }
                        items.push(row);
                    }

                    let flattenX = [];
                    if (chart.chartKind === 'STRIPE_CHART') {
                        const totalX = {};
                        for (let x of Object.keys(xAxis)) {
                            const key = chart.indicators[0].name;
                            let total = 0;
                            for (let row of xAxis[x]) {
                                const val = Number.parseFloat(row[key]);
                                total += (Number.isNaN(val) ? 0 : val);
                            }
                            totalX[x] = total;
                        }
                        flattenX = Object.keys(totalX).map(x => {
                            return { x, total: totalX[x] };
                        }).sort((a, b) => {
                            if (a.total > b.total) {
                                return 1;
                            } else if (a.total < b.total) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }).map(i => i.x);
                    } else {
                        flattenX = this.sortDimensions(chart, Object.keys(xAxis));
                    }
                    const namedVals = {}
                    for (let i = 0; i < flattenX.length; i++) {
                        for (let row of xAxis[flattenX[i]]) {
                            let key = chart.legends[0].name;
                            const dimVal = row[key] === undefined ? '未知' : row[key];
                            let vals = namedVals[dimVal];
                            if (vals === undefined) {
                                vals = new Array(flattenX.length).fill(0, 0, flattenX.length);
                                namedVals[dimVal] = vals;
                            }
                            key = chart.indicators[0].name;
                            vals[i] = Number.parseFloat(row[key]);
                        }
                    }
                    const values = [];
                    for (let name of Object.keys(namedVals)) {
                        values.push({ name, value: namedVals[name] });
                    }
                    chart.data = {
                        dimensions: this.sortDimensions(chart, values.map(v => v.name)),
                        xAxis: flattenX,
                        values: this.sortDimensions(chart, values)
                    };
                } else if (chart.indicators.length > 1) {
                    const xAxis = {};
                    for (let row of data) {
                        const key = chart.dimensions[0].name;
                        const dimVal = row[key] === undefined ? '未知' : row[key];
                        let items = xAxis[dimVal];
                        if (items === undefined) {
                            items = [];
                            xAxis[dimVal] = items;
                        }
                        items.push(row);
                    }

                    let flattenX = [];
                    if (chart.chartKind === 'STRIPE_CHART') {
                        const totalX = {};
                        for (let x of Object.keys(xAxis)) {
                            let total = 0;
                            for (let row of xAxis[x]) {
                                for (const indicator of chart.indicators) {
                                    const val = Number.parseFloat(row[indicator.name]);
                                    total += (Number.isNaN(val) ? 0 : val);
                                }
                            }
                            totalX[x] = total;
                        }
                        flattenX = Object.keys(totalX).map(x => {
                            return { x, total: totalX[x] };
                        }).sort((a, b) => {
                            if (a.total > b.total) {
                                return 1;
                            } else if (a.total < b.total) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }).map(i => i.x);
                    } else {
                        flattenX = this.sortDimensions(chart, Object.keys(xAxis));
                    }

                    const namedVals = {};
                    for (const i of chart.indicators) {
                        namedVals[i.name] = new Array(flattenX.length).fill(0, 0, flattenX.length);
                    }
                    for (let i = 0; i < flattenX.length; i++) {
                        for (let row of xAxis[flattenX[i]]) {
                            for (const indicator of chart.indicators) {
                                const key = indicator.name;
                                const val = row[key] === undefined ? 0 : Number.parseFloat(row[key]);
                                namedVals[indicator.name][i] = val;
                            }
                        }
                    }
                    const values = [];
                    for (let name of Object.keys(namedVals)) {
                        values.push({ name: getTitle(name), value: namedVals[name] });
                    }
                    //values.sort((a, b) => a.name < b.name);
                    chart.data = {
                        // dimensions: chart.indicators.map(i => getTitle(i.name)).sort(),
                        // xAxis: flattenX,
                        // values: values.sort((a, b) => a.name < b.name)
                        dimensions: this.sortDimensions(chart, chart.indicators.map(i => getTitle(i.name))),
                        xAxis: flattenX,
                        values: this.sortDimensions(chart, values)
                    }
                } else {
                    // TODO:
                    const xAxis = {};
                    for (let row of data) {
                        const key = chart.dimensions[0].name;
                        const dimVal = row[key] === undefined ? '未知' : row[key];
                        let items = xAxis[dimVal];
                        if (items === undefined) {
                            items = [];
                            xAxis[dimVal] = items;
                        }
                        items.push(row)
                    }
                    for (let dimVal of Object.keys(xAxis)) {
                        const key = chart?.indicators[0]?.name;
                        let value = 0;
                        for (let item of xAxis[dimVal]) {
                            value += Number.parseFloat(item[key]);
                        }
                        xAxis[dimVal] = value;
                    }
                    let flattenX = [];
                    if (chart.chartKind === 'STRIPE_CHART') {
                        flattenX = Object.keys(xAxis).map(x => {
                            return { x, total: xAxis[x] };
                        }).sort((a, b) => {
                            if (a.total < b.total) {
                                return -1;
                            } else if (a.total > b.total) {
                                return 1;
                            } else {
                                return 0;
                            }
                        }).map(i => i.x);
                    } else {
                        flattenX = this.sortDimensions(chart, Object.keys(xAxis));
                    }
                    chart.data = {
                        dimensions: flattenX,
                        xAxis: flattenX,
                        values: [{ name: chart.dimensions[0].name, value: flattenX.map(x => xAxis[x]) }],
                    };

                }
                break;
            case 'PIE_CHART': {
                const values = [];
                for (let row of data) {
                    const dim = chart.dimensions[0].name;
                    const val = chart.indicators[0].name;
                    values.push({
                        value: Number.parseFloat(row[val]),
                        name: row[dim] === undefined ? '未知' : row[dim]
                    });
                }
                chart.data = values;
            } break;
            case 'CARD_CHART': {
                const values = [];
                if (chart.dimensions.length === 0) {
                    for (let row of data) {
                        const key = chart.indicators[0].name;
                        values.push({
                            name: getTitle(key),
                            value: Number.parseFloat(row[key])
                        });
                    }
                } else {
                    for (let row of data) {
                        const dim = chart.dimensions[0].name;
                        const val = chart.indicators[0].name;
                        values.push({
                            value: Number.parseFloat(row[val]),
                            name: row[dim] === undefined ? '未知' : row[dim]
                        });
                    }
                }
                this.sortDimensions(chart, values);
                chart.data = values;
            } break;
            case 'FLATTEN_TABLE': {
                const cols = [];
                const colsFmt = [];
                for (const field of chart.dimensions) {
                    cols.push({ title: getTitle(field.name), name: field.name });
                    colsFmt.push({ type: 'text', readOnly: false });
                }
                for (const field of chart.legends) {
                    cols.push({ title: getTitle(field.name), name: field.name });
                    colsFmt.push({ type: 'text', readOnly: false });
                }
                for (const field of chart.indicators) {
                    cols.push({ title: getTitle(field.name), name: field.name });
                    colsFmt.push({ type: 'numeric', readOnly: false });
                }

                chart.data = {
                    cols,
                    colsFmt,
                    rows: data
                };
            } break;
            case 'TREE_MAP_CHART': {
                const values = [];
                const indicatorKey = chart.indicators[0].name;
                for (const key of chart.dimensions) {
                    const dim = {
                        name: getTitle(key.name),
                        value: 0,
                        children: [],
                    };

                    const children = {};
                    for (const row of data) {
                        const dimVal = ifEmpty(row[key.name], '未知');
                        if (children[dimVal] === undefined) {
                            children[dimVal] = {
                                name: dimVal,
                                value: 0,
                            };
                        }
                        const val = Number.parseFloat(row[indicatorKey]);
                        if (!Number.isNaN(val)) {
                            dim.value += val;
                            children[dimVal].value += val;
                        }
                    }
                    dim.children = Object.keys(children).map(key => {
                        return children[key];
                    });
                    values.push(dim);
                }
                //console.log(values);
                chart.data = values;
            } break;
            default:
                break;
        }
        chart.originalData = data;
    },

    sortDimensions(chart, cols) {
        const dim = chart.dimensions[0];
        const dimensionsOrder = chart.options.dimensionsOrder;
        let orderBy = dimensionsOrder ? dimensionsOrder[dim.name] : 'ASC';
        switch (orderBy) {
            case 'DESC':
                cols.sort((a, b) => {
                    const [k1, k2] = this.exactKeys(a, b);
                    return this.comparatorDesc(k1, k2);
                });
                break;
            case 'KEYS':
                const keys = dimensionsOrder[`${dim.name}:keys`];
                const dummy = [...cols];
                const resetSize = cols.length;
                for (const key of keys) {
                    const index = dummy.findIndex(a => {
                        if (isNotEmpty(a.name)) {
                            return a.name === key;
                        } else if (isNotEmpty(a.title)) {
                            return a.title === key;
                        } else {
                            return a === key;
                        }
                    });
                    if (index >= 0) {
                        const [removed] = dummy.splice(index, 1);
                        cols.push(removed);
                    }
                }
                dummy.sort((a, b) => {
                    const [k1, k2] = this.exactKeys(a, b);
                    return this.comparatorAsc(k1, k2);
                });
                for (const col of dummy) {
                    cols.push(col);
                }
                cols.splice(0, resetSize);
                break
            case 'ASC':
            default:
                cols.sort((a, b) => {
                    const [k1, k2] = this.exactKeys(a, b);
                    return this.comparatorAsc(k1, k2);
                });
                break;

        }
        return cols;
    },

    exactKeys(a, b) {
        if (typeof a === 'string' && typeof b === 'string') {
            return [a, b];
        } else if (isNotEmpty(a.name) && isNotEmpty(b.name)) {
            return [a.name, b.name];
        } else if (isNotEmpty(a.title) && isNotEmpty(b.title)) {
            return [a.title, b.title];
        } else {
            return ['', ''];
        }
    },

    comparatorAsc(a, b) {
        if (a < b) {
            return -1;
        } else if (a > b) {
            return 1;
        } else {
            return 0;
        }
    },

    comparatorDesc(a, b) {
        if (a < b) {
            return 1;
        } else if (a > b) {
            return -1;
        } else {
            return 0;
        }
    },

    evaluateRows(chart, data) {
        const calculating = chart.indicators
            .filter(i => i.name.startsWith('c:'))
            .map(i => chart.calculating.find(calc => calc.key === i.name))
            .filter(calc => calc !== undefined);

        if (calculating instanceof Array) {
            for (const row of data) {
                for (const calc of calculating) {
                    const val = this.evaluate(calc.ast, row);
                    //console.log(val, calc.ast, row);
                    if (typeof val === 'number') {
                        row[calc.key] = val;
                    }
                }
            }
        }
    },

    evaluate(expr, row) {

        if (isNotEmpty(expr.op)) {
            if (isEmpty(expr.lhs) || isEmpty(expr.rhs)) {
                return null;
            }
            const lhs = this.evaluate(expr.lhs, row);
            const rhs = this.evaluate(expr.rhs, row);
            //console.log(lhs, rhs);
            if (lhs === null || rhs === null) {
                return null;
            }
            switch (expr.op) {
                case '+':
                    return lhs + rhs;
                case '-':
                    return lhs - rhs;
                case '*':
                    return lhs * rhs;
                case '/':
                    const rv = lhs / rhs;
                    return Number.isNaN(rv) ? null : rv;
                default:
                    return null;
            }
        } else if (isNotEmpty(expr.name)) {
            const val = row[expr.name];
            if (val === null || val === undefined || Number.isNaN(val)) {
                return null;
            }
            if (typeof val === 'string') {
                const n = Number.parseFloat(val);
                return Number.isNaN(n) ? null : n;
            }
            return (typeof val === 'number') ? val : null;
        } else if (typeof expr.value === 'number') {
            return Number.isNaN(expr.value) ? null : expr.value;
        } else {
            return null
        }
    }
}

class ExprParser {

    static operatorsPrio = {
        '+': 10,
        '-': 10,
        '*': 20,
        '/': 20
    };

    constructor(sequence) {
        this.sequence = sequence;
        if (!this.sequence instanceof Array) {
            throw new ExprParsingException('输入错误', 0);
        }
        if (this.sequence.length < 1) {
            throw new ExprParsingException('输入错误', 0);
        }
        this.lookahead = this.sequence[0];
        this.index = 0;
    }

    parse() {
        const [expr] = this.parseExpr(0);
        if (!this.eof()) {
            throw new ExprParsingException(`未匹配到运算符：\`+ - * /,匹配到了：${JSON.stringify(this.lookahead)}`, this.index);
        }
        return expr;
    }

    parseExpr(limit) {
        let expr = this.parsePrimary();
        let op = this.token(this.peek());
        while (this.isOp(op) && ExprParser.operatorsPrio[op] > limit) {
            this.moveNext();
            const [rhs, nextOp] = this.parseExpr(ExprParser.operatorsPrio[op]);
            expr = { op, lhs: expr, rhs };
            op = nextOp;
        }
        return [expr, op];
    }

    parsePrimary() {
        const node = this.peek();
        switch (this.token(node)) {
            case 'CONST_VAL':
                this.moveNext();
                return { ...node };
            case 'COLUMN':
                this.moveNext();
                return { ...node };
            case '(':
                this.moveNext();
                const [expr] = this.parseExpr(0);
                this.match(')');
                return expr;
            default:
                throw new ExprParsingException(`未匹配到:常量/指标/括号()`, this.index)
        }
    }

    isOp(op) {
        switch (op) {
            case '+':
            case '-':
            case '*':
            case '/':
                return true;
            default:
                return false;
        }
    }

    match(token) {
        const want = this.token(this.peek());
        if (want === token) {
            this.moveNext();
        } else {
            throw new ExprParsingException(`未匹配到:${want}`, this.index);
        }
    }

    moveNext() {
        if (this.index + 1 >= this.sequence.length) {
            this.lookahead = { eof: true };
        } else {
            this.index++;
            this.lookahead = this.sequence[this.index];
        }
    }

    eof() { return this.lookahead.eof; }

    peek() { return this.lookahead; }

    token(node) {
        if (node.value !== undefined) {
            return 'CONST_VAL';
        } else if (isNotEmpty(node.name)) {
            return 'COLUMN';
        } else if (isNotEmpty(node.op)) {
            return node.op;
        } else if (node.eof) {
            return 'EOF';
        } else {
            throw new ExprParsingException(`错误的token:${JSON.stringify(node)}`, this.index);
        }
    }
}

class ExprParsingException {
    constructor(message, index) {
        this.message = message;
        this.index = index
    }
}

export { BlockChart, BarChart, PieChart, LineChart, CardChart, FlattenTableChart, ChartBundle, OptionsBundle, DataPreviewModal, Charts, ExprParser, ExprParsingException };